// import { CircularProgress } from '@mui/material';
// import { lazy, Suspense } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { CustomPageLoading } from '../components/muiCustom/customLoading';
import { isMobile } from '../env';

const HomePageBrowser = lazy(() => import('../pageBrowser/HomepageBrowser'));

const HomePage  = lazy(() => import('../pages/Homepage'));
const Account = lazy(() => import('../pages/account'));
const PrivacyPolicy = lazy(() => import('../pages/auth/privacyPolicy'));
const Terms = lazy(() => import('../pages/auth/terms'));
const TestLink = lazy(() => import('../pages/tools/testLink'));
const ProductDetail = lazy(() => import('../pages/productDetail'));
const TableOtherData = lazy(() => import('../pages/other/tableOtherData'));
const CreateVideoScript = lazy(() => import('../pageMobile/createScript/createVideoScript'));
const CreateProductScript = lazy(() => import('../pageMobile/createScript/createProductScript'));
const VideoScript = lazy(() => import('../pageMobile/videoScript'));

const PageBackend = lazy(() => import('../backendPage/pageBackend'));

const is_mobile = isMobile();

export default function MainRouter() {
  const HomePageBox = is_mobile ? HomePage : HomePageBrowser;

  return (
    <Router>
      <Routes>
        <Route path="/account/*" element={
          <Suspense fallback={<CustomPageLoading />}>
            <Account />
          </Suspense>
        } />
        <Route path="/privacy-policy" element={
          <Suspense fallback={<CustomPageLoading />}>
            <PrivacyPolicy />
          </Suspense>
        } />
        <Route path="/terms" element={
          <Suspense fallback={<CustomPageLoading />}>
            <Terms />
          </Suspense>
        } />
        <Route path="/test-link" element={
          <Suspense fallback={<CustomPageLoading />}>
            <TestLink />
          </Suspense> 
        } />
        <Route path="/product-detail" element={
          <Suspense fallback={<CustomPageLoading />}>
            <ProductDetail />
          </Suspense> 
        } />
        { is_mobile && (
          <>
            <Route path="/create-video-script" element={
              <Suspense fallback={<CustomPageLoading />}>
                <CreateVideoScript />
              </Suspense>
            } />
            <Route path="/create-product-script" element={
              <Suspense fallback={<CustomPageLoading />}>
                <CreateProductScript />
              </Suspense>
            } />
            <Route path="/video-script" element={
              <Suspense fallback={<CustomPageLoading />}>
                <VideoScript />
              </Suspense> 
            } />
          </>
        ) }

        <Route path="/backend/*" element={
          <Suspense fallback={<CustomPageLoading />}>
            <PageBackend />
          </Suspense> 
        } />
        

        <Route path="/table-other-data/:name" element={
          <Suspense fallback={<CustomPageLoading />}>
            <TableOtherData />
          </Suspense>
        } />
        
        <Route path="/*" element={
          <Suspense fallback={<CustomPageLoading />}>
            <HomePageBox />
          </Suspense>
        } />
        {/* <Route path="/"
          element={
             // is Login
            <ProtectedRoute path="/" element={<HomePage /> } />
          }
        /> */}
      </Routes>
    </Router>
  );
}
